"use client";
import { DonutChart } from "@carbon/charts-react";
import React, { useState } from "react";
import ProgressBar from "./ProgressBar";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";

const AssetAllocation = ({ assetAllocationData }) => {
  const [allocationFilterBtn, setAllocationFilterBtn] = useState("Equity");

  const handleAllocationFilterBtn = (allocation) => {
    setAllocationFilterBtn(allocation);
  };

  const data = [
    {
      group: "Other Cap",
      value:
        assetAllocationData &&
        assetAllocationData?.market_cap_allocation?.other_cap_percentage,
    },
    {
      group: "Large Cap",
      value:
        assetAllocationData &&
        assetAllocationData?.market_cap_allocation?.large_cap_percentage,
    },
    {
      group: "Mid Cap",
      value:
        assetAllocationData &&
        assetAllocationData?.market_cap_allocation?.midcap_percentage,
    },
    {
      group: "Small Cap",
      value:
        assetAllocationData &&
        assetAllocationData?.market_cap_allocation?.small_cap_percentage,
    },
  ];

  const options = {
    resizable: true,
    pie: {
      labels: {
        enabled: false,
      },
    },
    toolbar: {
      enabled: false,
    },
    data: {
      loading: false,
    },
    donut: {
      center: {
        label: "Market Cap",
        number: null,
        titleFontSize: (value) => 14,
        numberFontSize: (value) => 0,
        titleYPosition: (value) => 5,
      },
      alignment: "left",
    },
    legend: {
      position: "right",
      alignment: "center",
      padding: "0px",
      margin:"0px"
    },
    height: "130px",
  };

  const progressBarDummyDebitHolding = [
    { name: "Others", value: "8.06" },
    { name: "Reserve bank of india", value: "12.42" },
    { name: "ICICUI Bank Ltd", value: "17.06" },
    { name: "HDFC Bank Ltd", value: "5.06" },
    { name: "Others", value: "8.06" },
    { name: "Reserve bank of india", value: "12.42" },
    { name: "ICICUI Bank Ltd", value: "17.06" },
    { name: "HDFC Bank Ltd", value: "5.06" },
  ];

  const progressBarDummyAllocationByInstruments = [
    { name: "Foreign-Equity", value: "14.06" },
    { name: "CBLO", value: "12.42" },
    { name: "Certificate of Deposit", value: "17.06" },
    { name: "Cash Margin", value: "5.06" },
    { name: "Foreign-Equity", value: "14.06" },
    { name: "CBLO", value: "12.42" },
    { name: "Certificate of Deposit", value: "17.06" },
    { name: "Cash Margin", value: "5.06" },
  ];

  const [showMoreTopHolding, setShowMoreTopHoldings] = useState(false);

  const handleShowMoreTopHoldings = () => {
    setShowMoreTopHoldings(!showMoreTopHolding);
  };

  const [showMoreTopSectors, setShowMoreTopSectors] = useState(false);

  const handleShowMoreTopSectors = () => {
    setShowMoreTopSectors(!showMoreTopSectors);
  };

  const [showMoreTopDebit, setShowMoreTopDebit] = useState(false);

  const handleShowMoreTopDebit = () => {
    setShowMoreTopDebit(true);
  };

  const [showMoreTopAllocaton, setShowMoreTopAllocation] = useState(false);

  const handleShowMoreTopAllocaton = () => {
    setShowMoreTopAllocation(true);
  };
  return (
    <div className="m-4">
      <p className="font-bold text-2xl text-[#333333] mb-4">Asset Allocation</p>
      <div className="border border-solid border-[#E0E0E0] rounded-lg p-4 gap-4 w-[734px] h-max">
        <>
          {" "}
          <main className="p-4">
            <div className="flex  items-center gap-[158px] mb-4">
              <p className="text-[#333333] font-semibold text-sm mb-1">
                Allocation By Market Cap
              </p>
              {/* <p className="font-medium text-[10px] text-[#8B8B8B]">
                Values in %
              </p> */}
            </div>
            <div className="flex">
              <div className="flex flex-col items-center w-[280px] whitespace-nowrap">
                <DonutChart data={data} options={options}></DonutChart>
              </div>
              {/* <div className="ml-6 flex gap-3 flex-col mt-1">
                {data.map((item, index) => (
                  <div key={index} className="flex items-center mb-1">
                    <span className="w-3 h-3 rounded-full mr-2"></span>

                    <span className="ml-2 text-[10px] font-semibold text-[#262626]">
                      {item.value} %
                    </span>
                  </div>
                ))}
              </div> */}
            </div>
          </main>
          <div className="border-[#E2ECFF] border-b "></div>
          <div className="flex gap-4">
            <div>
              <div className="flex flex-row  justify-between w-[335px] pt-4 pb-2">
                <p className="text-[#333333] font-semibold text-sm">
                  Top Holdings
                </p>
                <p className="text-[#8B8B8B] font-medium text-[10px]">
                  Values in %
                </p>
              </div>
              {assetAllocationData?.holdings
                ?.slice(
                  0,
                  showMoreTopHolding ? assetAllocationData?.holdings?.length : 4
                )
                .map((item, index) => (
                  <div key={index}>
                    <ProgressBar
                      name={item.security}
                      value={item.holding_perc}
                    />
                  </div>
                ))}
              {assetAllocationData?.holdings?.length > 4 && (
                <div
                  className="flex items-center cursor-pointer mt-4 justify-center"
                  onClick={handleShowMoreTopHoldings}
                >
                  <p className="font-medium text-xs text-[#656565]">
                    {showMoreTopHolding ? "Show Less" : "Show More"}
                  </p>
                  {showMoreTopHolding ? (
                    <HiChevronUp size={"20px"} />
                  ) : (
                    <HiChevronDown size={"20px"} />
                  )}
                </div>
              )}
            </div>
            <div>
              <div className="flex flex-row  justify-between w-[335px] pt-4 pb-2">
                <p className="text-[#333333] font-semibold text-sm">
                  Top Sectors
                </p>
                <p className="text-[#8B8B8B] font-medium text-[10px]">
                  Values in %
                </p>
              </div>
              {assetAllocationData?.sectorwise_holdings
                ?.slice(
                  0,
                  showMoreTopSectors
                    ? assetAllocationData?.sectorwise_holdings?.length
                    : 4
                )
                .map((item, index) => (
                  <div key={index}>
                    <ProgressBar name={item.sector} value={item.holding_perc} />
                  </div>
                ))}
              {assetAllocationData?.sectorwise_holdings?.length > 4 && (
                <div
                  className="flex items-center cursor-pointer mt-4 justify-center"
                  onClick={handleShowMoreTopSectors}
                >
                  <p className="font-medium text-xs text-[#656565]">
                    {showMoreTopSectors ? "Show Less" : "Show More"}
                  </p>
                  {showMoreTopSectors ? (
                    <HiChevronUp size={"20px"} />
                  ) : (
                    <HiChevronDown size={"20px"} />
                  )}
                </div>
              )}
            </div>
          </div>
        </>
        {/* <div className="flex justify-center">
          <div className="flex w-max  border border-[#C3D5DC] items-center   gap-4 mb-4 rounded-full">
            <button
              className={`flex flex-col pl-5 py-2 text-[#333333] ${
                allocationFilterBtn === "Equity"
                  ? "bg-[#C3D5DC] rounded-full pr-3 pl-5 py-2"
                  : ""
              }`}
              onClick={() => handleAllocationFilterBtn("Equity")}
            >
              <p className="text-xs font-bold text-[#333333]">Equity</p>
              <p className="font-semibold text-[10px] text-[#8B8B8B]">
                (84.37%)
              </p>
            </button>
            <button
              className={` flex flex-col  pl-1 py-2 pr-3 text-[#333333] ${
                allocationFilterBtn === "Debit"
                  ? "bg-[#C3D5DC] rounded-full pr-3 pl-5 py-2"
                  : ""
              }`}
              onClick={() => handleAllocationFilterBtn("Debit")}
            >
              <p className="text-xs font-bold text-[#333333]">Debit</p>
              <p className="font-semibold text-[10px] text-[#8B8B8B]">
                (15.07%)
              </p>
            </button>
            <button
              className={`flex flex-col pl-1 py-2 pr-3 text-[#333333] ${
                allocationFilterBtn === "Other"
                  ? "bg-[#C3D5DC] rounded-full pr-3 pl-4 py-2"
                  : ""
              }`}
              onClick={() => handleAllocationFilterBtn("Other")}
            >
              <p className="text-xs font-bold text-[#333333]">Other</p>
              <p className="font-semibold text-[10px] text-[#8B8B8B]">
                (0.57%)
              </p>
            </button>
          </div>
        </div>
        <div className="border-[#E2ECFF] border-b "></div> */}
        {/* {allocationFilterBtn === "Equity" ? (
          <>
            {" "}
            <main className="p-4">
              <div className="flex  items-center gap-[158px] mb-4">
                <p className="text-[#333333] font-semibold text-sm mb-1">
                  Allocation By Market Cap
                </p>
                <p className="font-medium text-[10px] text-[#8B8B8B]">
                  Values in %
                </p>
              </div>
              <div className="flex">
                <div className="flex flex-col items-center w-[280px] whitespace-nowrap">
                  <DonutChart data={data} options={options}></DonutChart>
                </div>
                <div className="ml-6 flex gap-3 flex-col">
                  {data.map((item, index) => (
                    <div key={index} className="flex items-center mb-1">
                      <span className="w-3 h-3 rounded-full mr-2"></span>

                      <span className="ml-2 text-[10px] font-semibold text-[#262626]">
                        {item.value} %
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </main>
            <div className="border-[#E2ECFF] border-b "></div>
            <div className="flex gap-4">
              <div>
                <div className="flex flex-row  justify-between w-[335px] pt-4 pb-2">
                  <p className="text-[#333333] font-semibold text-sm">
                    Top Holdings
                  </p>
                  <p className="text-[#8B8B8B] font-medium text-[10px]">
                    Values in %
                  </p>
                </div>
                {progressBarDummy
                  .slice(0, showMoreTopHolding ? progressBarDummy.length : 4)
                  .map((item, index) => (
                    <div key={index}>
                      <ProgressBar name={item.name} value={item.value} />
                    </div>
                  ))}
                {!showMoreTopHolding && (
                  <div
                    className="flex items-center cursor-pointer mt-4 justify-center"
                    onClick={handleShowMoreTopHoldings}
                  >
                    <p className="font-medium text-xs text-[#656565]">
                      Show More
                    </p>
                    <img
                      src="/images/rightarrow.png"
                      className="w-[10px] h-[10px]"
                    />
                  </div>
                )}
              </div>
              <div>
                <div className="flex flex-row  justify-between w-[335px] pt-4 pb-2">
                  <p className="text-[#333333] font-semibold text-sm">
                    Top Sectors
                  </p>
                  <p className="text-[#8B8B8B] font-medium text-[10px]">
                    Values in %
                  </p>
                </div>
                {progressBarDummy1
                  .slice(0, showMoreTopSectors ? progressBarDummy1.length : 4)
                  .map((item, index) => (
                    <div key={index}>
                      <ProgressBar name={item.name} value={item.value} />
                    </div>
                  ))}
                {!showMoreTopSectors && (
                  <div
                    className="flex items-center cursor-pointer mt-4 justify-center"
                    onClick={handleShowMoreTopSectors}
                  >
                    <p className="font-medium text-xs text-[#656565]">
                      Show More
                    </p>
                    <img
                      src="/images/rightarrow.png"
                      className="w-[10px] h-[10px]"
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        ) : allocationFilterBtn === "Debit" ? (
          <>
            <div className="flex gap-4">
              <div>
                <div className="flex flex-row  justify-between w-[335px] pt-4 pb-2">
                  <p className="text-[#333333] font-semibold text-sm">
                    Top Debit Holding
                  </p>
                  <p className="text-[#8B8B8B] font-medium text-[10px]">
                    Values in %
                  </p>
                </div>
                {progressBarDummyDebitHolding
                  .slice(
                    0,
                    showMoreTopDebit ? progressBarDummyDebitHolding.length : 4
                  )
                  .map((item, index) => (
                    <div key={index}>
                      <ProgressBar name={item.name} value={item.value} />
                    </div>
                  ))}
                {!showMoreTopDebit && (
                  <div
                    className="flex items-center cursor-pointer mt-4 justify-center"
                    onClick={handleShowMoreTopDebit}
                  >
                    <p className="font-medium text-xs text-[#656565]">
                      Show More
                    </p>
                    <img
                      src="/images/rightarrow.png"
                      className="w-[10px] h-[10px]"
                    />
                  </div>
                )}
              </div>
              <div>
                <div className="flex flex-row  justify-between w-[335px] pt-4 pb-2">
                  <p className="text-[#333333] font-semibold text-sm">
                    Allocation by Instruments
                  </p>
                  <p className="text-[#8B8B8B] font-medium text-[10px]">
                    Values in %
                  </p>
                </div>
                {progressBarDummyAllocationByInstruments
                  .slice(
                    0,
                    showMoreTopAllocaton
                      ? progressBarDummyAllocationByInstruments.length
                      : 4
                  )
                  .map((item, index) => (
                    <div key={index}>
                      <ProgressBar name={item.name} value={item.value} />
                    </div>
                  ))}
                {!showMoreTopAllocaton && (
                  <div
                    className="flex items-center cursor-pointer mt-4 justify-center"
                    onClick={handleShowMoreTopAllocaton}
                  >
                    <p className="font-medium text-xs text-[#656565]">
                      Show More
                    </p>
                    <img
                      src="/images/rightarrow.png"
                      className="w-[10px] h-[10px]"
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        ) : allocationFilterBtn === "Other" ? (
          <></>
        ) : null} */}
      </div>
    </div>
  );
};

export default AssetAllocation;
